<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md8 lg8 xl6 style="text-align: center;">
                    <v-card class="elevation-1 pa-3">
                        <div class="moneyHeader yoprimary">
                            <label>
                                {{$t("lang.account.amountYocoin")}}:
                            </label>
                            <label>
                                {{account.amount}}
                            </label>
                        </div>
                        <div style="text-align: left">
                            <v-btn fab dark small class="yoprimary" title="Nạp Yocoin" @click="showAddYoCoin">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </div>
                        <div>
                            <v-data-table :headers="paymentHeaders" class="elevation-1"
                                          :pagination.sync="pagination"
                                          @update:pagination="onPaging"
                                          :rows-per-page-items="rowsPerPageItems"
                                          :total-items="totalRows"
                                          :items="paymentItems">
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-right">{{ props.item["yocoin"] }}</td>
                                    <td class="text-xs-left">{{ payTypeFormatter(props.item["paytype"])}}</td>
                                    <td class="text-xs-left">{{ statusFormatter(props.item["status"]) }}</td>
                                    <td class="text-xs-left">{{ props.item["createdAt"] | formatDateTime }}</td>
                                    <td class="text-xs-left">{{ props.item["vnpayTransaction"]}}</td>
                                    <td class="text-xs-left">
                                        <a :href="attachFormatter(props.item['attachId'])"
                                           v-if="props.item['attachId'] != null">
                                            <v-btn small fab color="primary">
                                                <v-icon>attach_file</v-icon>
                                            </v-btn>
                                        </a>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-btn small fab color="orange"
                                               v-if="props.item['status'] == 0 && props.item['paytype'] == 2"
                                               @click="editPayment(props.item)"
                                        >
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog v-model="addYoCoin" width="600px">
            <v-toolbar color="red" dark>
                <v-toolbar-title>{{$t('lang.account.addYocoin')}}</v-toolbar-title>
            </v-toolbar>
            <v-card>

                <v-card-text>
                    <div>
                        <v-radio-group v-model="payment.yocoin" style="width: 100%">
                            <div style="color:#3b5998;font-weight: bold;font-size: 20px">CHỌN SỐ TIỀN ĐỂ NẠP</div>
                            <div style="display: inline-block;" v-for="item in yocoinValue">
                                <v-radio :value="item.value" :label="item.text"/>
                            </div>
                        </v-radio-group>
                    </div>
                    <div>
                        <v-radio-group v-model="payment.paytype">
                            <div style="display: flex;padding: 10px;border:1px solid gray">
                                <div>
                                    <v-radio :value="1" label=""/>
                                </div>
                                <div style="display: flex">
                                    <img src="/img/pay/vnpay.png" style="width: 150px"/>
                                    <div>THANH TOÁN QUA VNPAY</div>
                                </div>
                            </div>
                            <div style="display: flex;padding: 10px;border:1px solid gray;margin-top:10px">
                                <div>
                                    <v-radio :value="2"/>
                                </div>
                                <div style="display: flex">
                                    <img src="/img/pay/transfer.png" style="width: 150px"/>
                                    <div>THANH TOÁN QUA CHUYỂN KHOẢN NGÂN HÀNG TRONG NƯỚC</div>
                                </div>
                            </div>
                        </v-radio-group>
                        <i-upload label="File chứng từ" name="attachId" id="attachId" v-show="payment.paytype==2"
                                  v-model="payment.attachId"/>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="cancel">
                        <v-icon dark left>cancel</v-icon>
                        {{ $t('lang.common.cancel') }}
                    </v-btn>
                    <v-btn color="primary" @click="executePayment">
                        <v-icon dark left>money</v-icon>
                        {{$t('lang.account.pay')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-content>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import IUpload from "../../components/form/Upload";

    export default {
        name: 'payment-page',
        components: {IUpload},
        data: () => {
            return {
                formName: "lang.userlog.title",
                account: {},
                yocoin:50,
                paytype:1,
                attachId:null,
                payment: {yocoin: 0, paytype: 1},
                yocoinValue: [
                    {value: 50, text: "50 Yocoin"},
                    {value: 100, text: "100 Yocoin"},
                    {value: 200, text: "200 Yocoin"},
                    {value: 500, text: "500 Yocoin"},
                    {value: 1000, text: "1000 Yocoin"}
                ],
                pagination: {
                    rowsPerPage: 20,
                    page: 1,
                    totalItems: 0
                },
                totalRows: 0,
                rowsPerPageItems: [10, 20, 50],
                paymentHeaders: [
                    {
                        text: "Yocoin",
                        align: "right",
                        sortable: false,
                        value: "yocoin",
                        width: "10%"
                    },
                    {
                        text: "Hình thức thanh toán",
                        align: "left",
                        sortable: false,
                        value: "paytype",
                        width: "15%"
                    },
                    {
                        text: "Trạng thái",
                        align: "left",
                        sortable: false,
                        value: "status",
                        width: "10%"
                    },
                    {
                        text: "Ngày",
                        align: "left",
                        sortable: false,
                        value: "createdAt",
                        width: "15%"
                    },
                    {
                        text: "Mã giao dịch VnPay",
                        align: "left",
                        sortable: false,
                        value: "vnpayTransaction",
                        width: "15%"
                    },
                    {
                        text: "File chứng từ",
                        align: "left",
                        sortable: false,
                        value: "attachId",
                        width: "10%"
                    },
                    {
                        text: "Sửa thông tin",
                        align: "left",
                        sortable: false,
                        width: "10%"
                    }

                ],
                paymentItems: [],
                addYoCoin: false,
            }
        },

        mounted() {
            this.getUserAccount();
            this.searchPayment();
        },

        watch:{
            payment:function(data){
                this.attachId = data.attachId;
            }
        },

        methods: {
            onPaging: function (page) {
                this.pagination = page;
                this.searchPayment();
            },

            payTypeFormatter: function (type) {
                let str = "";
                switch (type) {
                    case 1:
                        str = "VNPAY";
                        break;
                    case 2:
                        str = "Chuyển khoản";
                        break;

                }
                return str;
            },
            statusFormatter: function (status) {
                let str = "";
                switch (status) {
                    case 0:
                        str = "Chờ xác nhận";
                        break;
                    case 1:
                        str = "Đã xác nhận";
                        break;

                }
                return str;
            },

            attachFormatter: function (attachId) {
                if (attachId == null || attachId == undefined || attachId == "") {
                    return "";
                } else {
                    return process.env.VUE_APP_API_URL + "/download/attach/" + attachId;
                }

            },

            getUserAccount: function () {
                axios.post(process.env.VUE_APP_API_URL + "/payment/account").then(
                    data => {
                        if (data != null && data != "") {
                            this.account = data;
                        } else {
                            this.account = {
                                amount: 0
                            }
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            searchPayment: function () {
                let page = this.pagination.page;
                let pageSize = this.pagination.rowsPerPage;
                axios.post(process.env.VUE_APP_API_URL + "/payment/history?page=" + page + "&pageSize=" + pageSize).then(
                    data => {
                        this.paymentItems = data.items;
                        this.totalRows = data.count;
                    },
                    error => {
                        message.error(error);
                    }
                )
            },

            editPayment:function(payment){
                this.addYoCoin = true;
                for(let key in payment){
                    this.payment[key] = payment[key];
                }
                //this.payment = payment;
                console.log(this.payment);
                this.yocoin = this.payment.yocoin;
                this.paytype = this.payment.paytype;
                this.attachId = this.payment.attachId;
            },

            showAddYoCoin: function () {
                this.payment ={
                    'yocoin':50,
                    'paytype':1,
                    'attachId':-1};
                this.addYoCoin = true;
            },

            cancel: function () {
                this.addYoCoin = false;
                this.searchPayment();
            },

            executePayment: function () {
                axios.post(process.env.VUE_APP_API_URL + "/payment/vnpay", this.payment).then(
                    data => {
                        if (this.payment.paytype == 2) {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.cancel();
                            } else {
                                message.error(data.description);
                            }
                        } else {
                            window.location.href = data.url;
                        }
                    },
                    error => {
                        message.error(error);
                    }
                )
            }
        }
    }
</script>
